import { useEffect, useState } from 'react';

import isNil from 'Lib/utils/isNil';

type Option = {
  width?: number;
  height?: number;
};

const hasDimension = (width: number | undefined, height: number | undefined) =>
  !(isNil(width) || isNil(height));

const useDisplaySize = (imageRef: React.RefObject<any>, { width, height }: Option) => {
  const [dimension, setDimension] = useState({
    displayWidth: width,
    displayHeight: height,
  });

  const shouldMeasureSize = !hasDimension(dimension.displayWidth, dimension.displayHeight);

  useEffect(() => {
    const img = imageRef.current;
    if (img) {
      setDimension({
        displayWidth: img.offsetWidth,
        displayHeight: img.offsetHeight,
      });
    }
  }, [imageRef, shouldMeasureSize]);

  return dimension;
};

export default useDisplaySize;
